import { ChangeDetectionStrategy, Component, input, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ArrowLineComponent } from '../../atoms';
import { StatusIconComponent } from '../status-icon/status-icon.component';
import { ProgressionStateType } from '../../../interfaces';
import { IconProp } from '@fortawesome/angular-fontawesome/types';
import { faHeadset, faTruckPickup, faCar } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'shared-status-progression',
  standalone: true,
  imports: [CommonModule, ArrowLineComponent, StatusIconComponent],
  templateUrl: './status-progression.component.html',
  styleUrl: './status-progression.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatusProgressionComponent {
  step = input.required<number>();

  readonly ProgressionStateTypeEnum = ProgressionStateType;
  agentIcon: IconProp = faHeadset;
  pickupIcon: IconProp = faTruckPickup;
  carIcon: IconProp = faCar;

  calculateStep(step: number) {
    if (this.step() > step) {
      return ProgressionStateType.Done;
    }
    if (this.step() === step) {
      return ProgressionStateType.Current;
    }
    return ProgressionStateType.None;
  }
}
